import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import Divider from "@mui/material/Divider";
import Collapse from "@mui/material/Collapse";
import Dialog from "@mui/material/Dialog";
import { useCallback, useMemo, useState } from "react";
import EditContentTabs from "../../../editContentTabs";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import PrivateComponent from "../../../../providers/PrivateComponent/PrivateComponent";
import { PERMISSIONS } from "../../../../utils/constants";

export function MatchNode({ projectId, sport, item, level, getContent, setContent, getContentKeys }) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [dialog, setDialog] = useState(false);

  const children = useMemo(() => {
    const mergedChildrenHash = {};
    const children = [];
    item.children.forEach((item) => {
      if (item.unionKey) {
        mergedChildrenHash[item.unionKey] = [...(mergedChildrenHash[item.unionKey] || []), item];
      } else {
        children.push(item);
      }
    });

    Object.values(mergedChildrenHash).forEach((mergedItems) => {
      if (mergedItems.length === 1) {
        return children.push({ ...mergedItems[0], name: `${mergedItems[0].name} ( ${mergedItems[0].source} )` });
      }

      const sortedItems = mergedItems.sort((a, b) => a.priority - b.priority);
      const unifiedItem = { ...sortedItems[0] };

      let name = `${unifiedItem.name} ( ${unifiedItem.source}`;
      mergedItems.slice(1).forEach((item) => {
        name += ` - ${item.source}`;
        unifiedItem.children = [...unifiedItem.children, ...item.children];
      });
      name += ' )';
      unifiedItem.name = name;
      children.push(unifiedItem);
    });
    return children.sort((a, b) => a.displayOrder - b.displayOrder || a.name.localeCompare(b.name));
  }, [item.children]);

  const openDialog = () => {
    setDialog(true);
  };
  const closeDialog = () => {
    setDialog(false);
  };

  const padding = useMemo(() => {
    return 2 * level;
  }, [level]);

  const toggleCollaps = useCallback(() => {
    setIsCollapsed(!isCollapsed);
  }, [isCollapsed]);

  const handleGetContent = useCallback(async (contentKey) => {
    const data = await getContent(contentKey);
    return data;
  }, [getContent]);

  const handleSetContent = useCallback(async (contentKey, content) => {
    const data = await setContent(contentKey, content);
    return data;
  }, [setContent]);

  return (
    <div>
      <Dialog fullScreen open={dialog} onClose={closeDialog}>
        <EditContentTabs
          item={item}
          keys={getContentKeys({ item, level })}
          closeDialog={closeDialog}
          getContent={handleGetContent}
          setContent={handleSetContent}
        />
      </Dialog>
      <List disablePadding>
        <Divider />
        <ListItemButton
          sx={{
            paddingLeft: padding,
            background: "#f9f9f9",
            display: "flex",
            justifyContent: "space-between",
          }}
          onClick={toggleCollaps}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "25px" }}>
              {item.children.length ? (
                isCollapsed ? (
                  <ExpandLessIcon />
                ) : (
                  <ExpandMoreIcon />
                )
              ) : (
                <div style={{ paddingRight: "24px" }}></div>
              )}
              {item.name}
            </div>
            <PrivateComponent permission={PERMISSIONS.ALLOW_WRITE_MATCH_CENTER}>
              <Button variant="outlined" color={"warning"} onClick={openDialog}>
                Edit
              </Button>
            </PrivateComponent>
          </div>
        </ListItemButton>
        <Divider />
      </List>
      <Collapse in={isCollapsed}>
        {isCollapsed &&
          children.map((children) => (
            <MatchNode
              key={children.contentKey}
              projectId={projectId}
              sport={sport}
              item={children}
              level={level + 1}
              getContent={getContent}
              setContent={setContent}
              getContentKeys={getContentKeys}
            />
          ))}
      </Collapse>
    </div>
  );
}
